import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import HeaderBottom from '../../components/HomePage/HeaderBottom';

const EditFAQitemOne = () => {
    const {id} = useParams();
    const [item, setItem] = useState([]);

    useEffect(() => {
        fetch(`https://seo-for-small-business-01-b3162645ffd8.herokuapp.com/faq-item-one/${id}`)
            .then((res) => res.json())
            .then((info) => setItem(info));
    }, []);

    const handleAddItem = (event) => {
        event.preventDefault();
        const accodingTitleOne = event.target.accodingTitleOne.value;
        const accodingTextOne = event.target.accodingTextOne.value;
        

        const itemSection = {
            accodingTitleOne,
            accodingTextOne
            
        };

        const url = `https://seo-for-small-business-01-b3162645ffd8.herokuapp.com/faq-item-one/${id}`;
        fetch(url, {
            method: "PUT",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify(itemSection),
        })
            .then((res) => res.json())
            .then((result) => {

                alert(' FAQ Item is Updated');
            });
    };


    return (
     <>   
    
        <div className='container vh-100 d-flex align-items-center justify-content-center'>
     <form class="contact-form" onSubmit={handleAddItem}>
         <div class="row">
             <div class="col-lg-12">
                 <div class="contact-field p-relative c-name ">
                     <input class="form-control form-control-lg shadow-lg p-3 mb-3  bg-white rounded" name="accodingTitleOne" defaultValue={item.accodingTitleOne} placeholder="FAQ Title" required />
                 </div>
             </div>

             <div class="col-lg-12">
                 <div class="contact-field p-relative c-name ">
                     <input class="form-control form-control-lg shadow-lg p-3 mb-3 bg-white rounded" name="accodingTextOne" defaultValue={item.accodingTextOne} placeholder="FAQ Text" required />
                 </div>
             </div>
          

             <div class="slider-btn text-center">
                 <button class="btn btn-primary btn-lg " data-animation="fadeInRight"  data-delay=".8s"> FAQ Update </button>
             </div>
         </div>

     </form>

 </div></>
    );
};

export default EditFAQitemOne;